import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
const AsImg1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/02. 자일분당.c3ac2bc0b3887c749a6f.png`;
const AsImg2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/03. 자일평촌.05ef45eb531abc5cc13a.png`;
const AsImg3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/04. 자일일산.e6dcb8cc72c34e8492f9.png`;
const AsImg4 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/05. 자일청주.1ee0aa47e5571c386174.png`;
const AsImg5 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/06. 자일익산.cc45034af1b8a1f5ce2c.png`;
const AsImg6 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/07. 자일남대구.35271e1d65b91554244b.png`;
const AsImg7 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/08. 자일포항.f2e01db74beb96d73750.png`;
const AsImg8 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/09. 자일월암.826ae0765853175c5de3.png`;
const AsImg9 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/10. 자일사상.ca71c7d980260a531c32.png`;
const AsImg10 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/11. 자일김해.993a8513d2b4bf7f2989.png`;
const AsImg11 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/12. 자일양산.3b07cc630447e3da0a21.png`;
const AsImg12 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/13. 자일제주.4b0daf39b59dc31a4ab7.png`;
const Introduce = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"자동차판매사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <div className="kor">자동차사업</div>
              <div className="eng">Car Business</div>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"320px"}>
            <S.NavItem>
              <Link to="/CarBusiness/AsService">
                <div className="kor">AS정비사업</div>
                <div className="eng">AS maintenance business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/introduce">
                              <div className="kor">자동차사업</div>
                              <div className="eng">Car Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/Sales">
                              <div className="kor">자동차 판매사업</div>
                              <div className="eng">Automotive Sales Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/AsService">
                              <div className="kor">AS정비사업</div>
                              <div className="eng">AS maintenance business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/RentalService">
                              <div className="kor">렌터카 사업</div>
                              <div className="eng">Vehicle Rental Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/AsParts">
                              <div className="kor">A/S 부품 사업</div>
                              <div className="eng">After-Sales (A/S) Parts Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/CarBusinessHistory">
                              <div className="kor">자동차사업이력</div>
                              <div className="eng">Major business history</div>
                            </Link>
                          </S.NavItem>
                        </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"전국 A/S정비사업(11곳)"} titleeng={"Nationwide A/S Maintenance Operations (11 Locations)"} />
            <S.AsList>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">1. 자일분당서비스㈜</div>
                  <div className="eng">1. Zile Bundang Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg1} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 568평
                    <br />
                    위치: 경기도 성남시 분당구 대왕판교로 148
                    <br />
                    정비처리 능력: 연간 24,000대
                    <br />
                    정비차종: 쉐보레, 테슬라, BYD, 레스타, 스바루
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                    Factory Size: 1,900 square meters
                    <br />
                    Location: 148 Daewang Pangyo-ro, Bundang-gu,
                    <br />
                    Seongnam-si, Gyeonggi-do
                    <br />
                    Maintenance Capacity: 24,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, Tesla, BYD, Lestar, Subaru
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">2. 자일평촌서비스㈜</div>
                  <div className="eng">2. Zile Pyungchon service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg2} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 1,254평
                    <br />
                    위치: 경기도 안양시 동안구 벌말로 40
                    <br />
                    정비처리 능력: 연간 23,000대
                    <br />
                    정비차종: 쉐보레, 테슬라, BYD, 레스타
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                    <br />
                    Factory Size: 4,150 square meters
                    <br />
                    Location: 40 Beolmal-ro, Dongan-gu, Anyang-si, Gyeonggi-do
                    <br />
                    Maintenance Capacity: 23,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, Tesla, BYD, Lestar
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">3. 자일일산서비스㈜</div>
                  <div className="eng">3. Zyle Ilsan Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg3} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 2,499평
                    <br />
                    위치: 경기도 고양시 일산서구 경의로 848
                    <br />
                    정비처리 능력: 연간 29,000대
                    <br />
                    정비차종: 쉐보레, 캐딜락, BYD, 대우버스(전차종), 이스즈
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                  Factory Size: 8,300 square meters
                    <br />
                    Location: 848 Gyeongui-ro, Ilsanseo-gu, Goyang-si, Gyeonggi-do
                    <br />
                    Maintenance Capacity: 29,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, Cadillac, BYD,
                    <br />
                    Daewoo Bus (all models), Isuzu
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">4. 자일청주서비스㈜</div>
                  <div className="eng">4. Zyle Cheongju Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg4} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 3,005평
                    <br />
                    위치: 충청북도 청주시 사운로 370
                    <br />
                    정비처리 능력: 연간 20,000대
                    <br />
                    정비차종: 쉐보레, BYD, 대우버스(전차종), 타타트럭
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                    Factory Size: 9,950 square meters
                    <br />
                    Location: 370 Saun-ro, Cheongju-si, 
                    <br />
                    Chungcheongbuk-do, South Korea
                    <br />
                    Maintenance Capacity: 20,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, BYD, 
                    <br />
                    Daewoo Bus(all models), Tata Trucks
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">5. 자일익산서비스㈜</div>
                  <div className="eng">5. Zyle Iksan Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg5} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 2,118평
                    <br />
                    위치: 전라북도 익산시 서동로 242
                    <br />
                    정비처리 능력: 연간 15,000대
                    <br />
                    정비차종: 쉐보레, BYD, 레스타
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                    Factory Size: 7,000 square meters
                    <br />
                    Location: 242 Seodong-ro, Iksan-si, Jeollabuk-do
                    <br />
                    Maintenance Capacity: 15,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, BYD, Lestar
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">6. 자일남대구서비스㈜</div>
                  <div className="eng">6. Zyle Namdaegu Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg6} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 2,126평
                    <br />
                    위치: 대구시 달서구 진천로 110
                    <br />
                    정비처리 능력: 연간 20,000대
                    <br />
                    정비차종: 쉐보레, BYD, 레스타
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                  Factory Size: 7,050 square meters
                    <br />
                    Location: 110 Jincheon-ro, Dalseo-gu, Daegu
                    <br />
                    Maintenance Capacity: 20,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, BYD, Lestar
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">7. 자일포항서비스㈜</div>
                  <div className="eng">7. Zyle Pohang Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg7} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 4,075평
                    <br />
                    위치: 경상북도 포항시 남구 연일읍 철강로 119
                    <br />
                    정비처리 능력: 연간 19,000대
                    <br />
                    정비차종: 쉐보레, BYD, 대우버스(전차종), 타타트럭
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                  Factory Size: 13,500 square meters
                    <br />
                    Location: 119 Cheolgang-ro, Yeonil-eup, Nam-gu, 
                    <br />
                    Pohang- si, Gyeongsangbuk-do
                    <br />
                    Maintenance Capacity: 19,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, BYD, Daewoo
                    <br />
                    Bus (all models), Tata Truck
                  </div>
                </div>
              </S.AsItem>
             
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">8. 자일사상서비스㈜</div>
                  <div className="eng">8. Zyle Sasang Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg9} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 860평
                    <br />
                    위치: 부산시 사상구 가야대로 21
                    <br />
                    정비처리 능력: 연간 13,000대
                    <br />
                    정비차종: 쉐보레, 캐딜락, BYD, 레스타
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                  Factory Size: 2,850 square meters
                    <br />
                    Location: 21 Gayadaero, Sasang-gu, Busan
                    <br />
                    Maintenance Capacity: 13,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, Cadillac, BYD,
 Lestar
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">9. 자일김해서비스㈜</div>
                  <div className="eng">9. Zyle Gimhae Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg10} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 2,170평
                    <br />
                    위치: 경상남도 김해시 삼안로 41
                    <br />
                    정비처리 능력: 연간 16,000대
                    <br />
                    정비차종: 쉐보레, BYD, 대우버스(전차종), 타타트럭
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                  Factory Size: 7,200 square meters
                    <br />
                    Location: 41 Saman-ro, Gimhae-si, Gyeongsangnam-do
                    <br />
                    Maintenance Capacity: 16,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, BYD, Daewoo
                    <br />
                    Bus (all models), Tata Trucks
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">10. 자일양산서비스㈜</div>
                  <div className="eng">10. Zyle Yangsan Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg11} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 1,822평
                    <br />
                    위치: 경상남도 양산시 신기로 120
                    <br />
                    정비처리 능력: 연간 18,000대
                    <br />
                    정비차종: 쉐보레, BYD, 레스타
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                    Factory Size: 6,000 square meters
                    <br />
                    Location: 120 Singi-ro, Yangsan-si, Gyeongsangnam-do
                    <br />
                    Maintenance Capacity: 18,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, BYD, Lestar
                  </div>
                </div>
              </S.AsItem>
              <S.AsItem>
                <div className="as-item-title">
                  <div className="kor">11. 자일제주서비스㈜</div>
                  <div className="eng">11. Zyle Jeju Service</div>
                </div>
                <div className="as-item-imgArea">
                  <img src={AsImg12} alt="" className="as-item-img" />
                </div>

                <div className="as-item-text">
                  <div className="kor">
                    <h3>사업장 현황</h3>
                    공장규모: 1,551평
                    <br />
                    위치: 제주시 선반남2길 63
                    <br />
                    정비처리 능력: 연간 15,000대
                    <br />
                    정비차종: 쉐보레, BYD, 대우버스(전차종),
                    <br />
                    재규어/랜드로버, 닛산/인피니티
                  </div>
                  <div className="eng">
                    <h3>Business Status</h3>
                  Factory Size: 5,150 square meters
                    <br />
                    Location: 63 Seonban-nam 2-gil, Jeju-si, Jeju-do
                    <br />
                    Maintenance Capacity: 15,000 units annually
                    <br />
                    Maintenance Vehicle Types: Chevrolet, BYD, Daewoo 
                    <br />
                    Bus (all models), Jaguar/Land Rover, Nissan/Infiniti
                  </div>
                </div>
              </S.AsItem>
            </S.AsList>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Introduce;
